import { getStackUtil } from '../utility';
import { createElement } from './stack-element';
const { size, push, open, close } = getStackUtil();
const createMarkdownNode = (element) => {
    const node = Object.assign(Object.assign({}, element.props), { type: element.type });
    if (element.children) {
        node.children = element.children;
    }
    if (element.value) {
        node.value = element.value;
    }
    return node;
};
const openNode = (ctx) => (type, value, props) => open(ctx)(createElement(type, [], value, props));
const addNode = (ctx) => (type, children, value, props) => {
    const element = createElement(type, children, value, props);
    const node = createMarkdownNode(element);
    push(ctx)(node);
    return node;
};
const closeNode = (ctx) => () => {
    const element = close(ctx);
    return addNode(ctx)(element.type, element.children, element.value, element.props);
};
const openMark = (ctx) => (mark, type, value, props) => {
    const isIn = mark.isInSet(ctx.marks);
    if (isIn) {
        return;
    }
    ctx.marks = mark.addToSet(ctx.marks);
    openNode(ctx)(type, value, props);
};
const closeMark = (ctx) => (mark) => {
    if (!mark.isInSet(ctx.marks))
        return null;
    ctx.marks = mark.type.removeFromSet(ctx.marks);
    return closeNode(ctx)();
};
const build = (ctx) => () => {
    let doc = null;
    do {
        doc = closeNode(ctx)();
    } while (size(ctx));
    return doc;
};
export const createStack = () => {
    const ctx = {
        marks: [],
        elements: [],
    };
    return {
        build: build(ctx),
        openMark: openMark(ctx),
        closeMark: closeMark(ctx),
        openNode: openNode(ctx),
        addNode: addNode(ctx),
        closeNode: closeNode(ctx),
    };
};
//# sourceMappingURL=stack.js.map